import React from 'react';

import fetch from './fetch';

import moment from 'moment';

import utils from './../utils';

import {Modal, message} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const columns = utils.columns([
    {key:'$index', label: '序号'},

    {key:'termName', label: '学期名称'},
    {key:'bgDate', label: '开始日期', render: (value)=> moment(new Date(value)).format('YYYY/MM/DD')},
    {key:'endDate', label: '结束日期', render: (value)=> moment(new Date(value)).format('YYYY/MM/DD')},
    {key:'isCurrent', label: '是否为当前学期', render: (value)=> value === 1 ? '是' : '否'},
    {key:'termType', label: '类型', render: (value)=> value === 1 ? '学期' : '学年'},
    {
        key: 'termNum', 
        label: '所属学期', 
        render: (d) => {
            if (d == 1) {
                return '第一学期';
            } else if (d == 2) {
                return '第二学期';
            }
        }
    }
]);

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.get('term/get/'+ id, {})
    .then(response => response.payload.data)
    .catch(error => {
        // console.log('error');
    });
}

/**
 * @method querySearchTermName
 * @param {object} keywords
 * @return {promise}
 */
const querySearchTermName = (keywords ={}) => {
    return fetch.post('term/term/list', keywords)
    .then(response => {
        return response.payload.data.map(d => ({
            id: d.id,
            name: d.termName
        }));
    })
    .then((data) => {
        const names = data.map(d => d.id);
        const maps = {};
        data.forEach(d => {
            const termId = d.id;
            const termName = d.name;
            maps[d.id] = {
                termId,
                termName
            };
        });
        return {names, maps};
    });
}

const querySearchTermCurrentYear = (keywords ={}) => {
    return fetch.post('term/current/year', keywords)
    .then(response => {
        return response.payload.data.map(d => ({
            id: d.id,
            name: d.termName
        }));
    })
    .then((data) => {
        const names = data.map(d => d.id);
        const maps = {};
        data.forEach(d => {
            const termId = d.id;
            const termName = d.name;
            maps[d.id] = {
                termId,
                termName
            };
        });
        return {names, maps};
    });
}


/**
 * @method querySearchTermName
 * @param {object} keywords
 * @return {promise}
 */
const querySearchTermYear = (keywords ={}) => {
    return fetch.post('term/year/list', keywords)
    .then(response => {
        return response.payload.data.map(d => ({
            id: d.id,
            name: d.termName
        }));
    })
    .then((data) => {
        const names = data.map(d => d.id);
        const maps = {};
        data.forEach(d => {
            const termId = d.id;
            const termName = d.name;
            maps[d.id] = {
                termId,
                termName
            };
        });
        return {names, maps};
    });
}
/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('term/list', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method insert
 * @param {array} data
 * @return {promise}
 */
const insert = (data) => {
    return fetch.post('term/insert', data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '学期信息添加成功!',
                content: (
                    <div>
                        <p>点击确认后，将自动跳转到学期管理页面！</p>
                    </div>
                ),
                onOk() {
                    DataGrid.selections = [];                    
                },
                okText:"确认",
            });
        }
    });
}

/**
 * @method update
 * @param {uuid} id 
 * @param {object} data
 * @return {promise}
 */
const update = (id, data) => {
    return fetch.post('term/update/' + id, data)
    .then(response => {
        if(response.code === 200) {
            Modal.success({
                title: '学期信息更新成功!',
                content: (
                    <div>
                        <p>点击确认后，将自动跳转到学期管理页面！</p>
                    </div>
                ),
                onOk() {
                    DataGrid.selections = [];
                },
                okText:"确认",
            });
        }
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('term/remove/', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}


/**
 * @method last
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const lasts = (ids) => {
    return fetch.post('term/last')
    .then(response => {
        return response.payload.data;
    }).catch(error => {
        return error;
    });
}
//term/last

/**
 * @method lastYear
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
 const lastYear = (ids) => {
    return fetch.post('term/last/year')
    .then(response => {
        return response.payload.data;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = () => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        DataGrid.refresh();
                        DataGrid.selections = [];
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}


/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'term'+ url;
};

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

const getSelection =() => {
    return DataGrid.selections;
}

export default {
    insertURL: '#/term/insert',
    querySearchById,
    querySearchTermName,
    querySearchTermYear,
    insert,
    update,
    querySearch,
    remove,
    columns,
    onSelect,
    batchRemove,
    setRefresh,
    batchUpdate,
    lastYear,
    redirect,
    lasts,
    getSelection ,
    querySearchTermCurrentYear
}